<template>
    <div>
    
     <div>
       <v-row justify="center">
       <v-dialog v-model="dialog" persistent max-width="290">
        <v-overlay :value="$store.state.isloading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
         <v-card>
           <v-card-title class="headline">Selecione o Trimestre</v-card-title>
            <v-col cols="12" md="12" >
               <v-select
                 v-model="trimestre"
                 item-value="idTrimestre"
                 item-text="descricao"
                 :items="trimestres"
                  filled
                 color="blue-grey lighten-2"
                 label="Trimestre"
                 return-object
               ></v-select>
             </v-col>
             <v-card-actions>
             <v-spacer></v-spacer>
             <v-btn color="red" text @click="fecharPopUp()">Cancelar</v-btn>
              <v-btn color="green darken-1" text :disabled="!trimestre" @click="carregarRelatorio()">Concordar</v-btn>
           </v-card-actions>
         </v-card>
       </v-dialog>
     </v-row>
     </div>
  
    </div>
   </template>
  <script>
import axios from '../../../plugins/axios'
import utilitario from '../../../plugins/utilitarios'
import Swal from 'sweetalert2'
  const ls = require('local-storage')
  export default {
    data: () => ({
      israscunho: true,
      rascunhoimge: '',
      relatorio: [],
      dialog: true,
      listaAlunos: [],
      configuracoesReport: [],
      html: ``,
      trimestre: 0,
      trimestres: [
        { idTrimestre: 1, descricao: '1º Trimestre', relatorio: 'btt' },
        { idTrimestre: 2, descricao: '2º Trimestre', relatorio: 'btt' },
        { idTrimestre: 3, descricao: '3º Trimestre', relatorio: 'btt' },],
        pagamento: []
    }),
    computed: {
        isintegrado(){  return ls.get('isintegrado') },
        logotipo(){  return (ls.get('isintegrado') ? ls.get('logotipo') : ls.get('insignia')) },
        instituicaodescricao() { return ls.get('instituicaodescricao') },
        instituicaoId() { return ls.get('i_id') }
    },
    created () {
      this.carregarPagamento()
    },
  
    methods: {
      async carregarPagamento () {
       try {
         let params = {anolectivo: this.$store.state.objturma.anoLectivo,idemolumento: 1} 
         this.pagamento = await axios.post('/getPagamentosEmolumentosByEmolumento', params).then(res => res.data)  
         this.rascunhoimge = this.rascunho()
       } catch (error) {
         Swal.fire({icon: 'error',title: '',text: 'Ocorreu um erro ao carregar pagamento'})
       }
     },
     rascunho () {
      try {
        const cobrancaboletim = this.$store.state.actividades.filter(t=>t.descricao === "Cobrança de Boletim")
        let iscobrancaboletim = true
      if(cobrancaboletim.length){
        iscobrancaboletim = (cobrancaboletim[0].status_2 == 1 ? true : false)
      }
      this.israscunho = (!iscobrancaboletim || (this.pagamento.length && this.pagamento[0].bloqueio))? false : true
       return (!iscobrancaboletim || (this.pagamento.length && this.pagamento[0].bloqueio))? '' : ls.get('urlReport') + 'readfile/rascunho-1.png'
      } catch (error) {
        return iscobrancaboletim
      }
      
     },
        async carregarRelatorio() {
            try {
                this.relatorio = await axios.get('/obterRelatorioByDescricao/' + this.trimestre.relatorio).then(res => res.data)
                if (!this.relatorio.length) {  Swal.fire('Informação', 'Boletim não configurado!', 'info') }  else this.carregaBoletim()
            } catch (error) {
               this.fecharPopUp()
                Swal.fire({ icon: 'error', title: 'Informação!', text: 'Ocorreu um erro ao carregar o relatório' })
            }
    },
    async carregaBoletim () {
            this.dialog = false
            this.$store.state.isloading = true
            try {
                this.listaAlunos = await axios.post('/boletimTurma', { turma: this.$store.state.objturma, trimestre: this.trimestre.idTrimestre }).then(res => res.data)
                if(this.listaAlunos.length)this.comporHtml()
            } catch (error) {
                Swal.fire({ icon: 'error', title: 'Informação!', text: 'Ocorreu um erro ao carregar as notas' })
            }
    },
    descricaoEscola() {
      let configuracaoInstituto = ls.get('configuracoesReport').filter(c => c.obs === 'nome_escola')
      return (this.instituicaoId === 1) ? (configuracaoInstituto[0].valor).toUpperCase() : (this.$store.state.objturma.idCurso <= 24 ? this.instituicaodescricao.toUpperCase() : (configuracaoInstituto[1].valor).toUpperCase())
    },
    async comporHtml () {
        try {
          
          const msgRascunho = '#'
            this.html = this.relatorio[0].documento.replace(/{{trimestre_1_2}}/g, (this.trimestre.idTrimestre === 3 ? '' : this.relatorio[0].documentoiteracao2))
            // this.html = this.relatorio[0].documento.replace(/{{trimestre_1_2}}/g, (this.relatorio[0].documentoiteracao2))
            let documentoiter = this.relatorio[0].documentoiteracao1
            let elementold = this.listaAlunos[0]
            let assinatura = (ls.get('i_id') === 24 ? 'O(A) Director(a) de Turma' : 'O Coordenador do Curso')
            let dados = ``
            let boletim = this.html
            let instituicaodescricao = this.descricaoEscola()

            for (let index = 0; index < this.listaAlunos.length; index++) {
                const element = this.listaAlunos[index]
                
          if (element.pkInscricao_na_turma !== elementold.pkInscricao_na_turma || this.listaAlunos.length === (index + 1)) {
            boletim = boletim.replace(/{{dados}}/g, dados)
            dados = ``
            boletim += (this.listaAlunos.length === (index + 1) ? '' : this.html)
            boletim = boletim.replace(/{{instituicaodescricao}}/g, instituicaodescricao)
            boletim = boletim.replace(/{{insignia}}/g, ls.get('insignia'))
            boletim = boletim.replace(/{{logotipo}}/g, ls.get('logotipo'))            
            boletim = boletim.replace(/{{anolectivo}}/g, this.$store.state.novadescricaoSelecionado)
            boletim = boletim.replace(/{{curso}}/g, this.$store.state.objturma.curso)
            boletim = boletim.replace(/{{turma}}/g, this.$store.state.objturma.turmadescricao)
            boletim = boletim.replace(/{{classe}}/g, this.$store.state.objturma.classe_descricao.substring(0, 3))
            boletim = boletim.replace(/{{periodo}}/g, this.$store.state.objturma.periodo)
            boletim = boletim.replace(/{{dataactual}}/g, utilitario.correntDateByUnderstanding())
            boletim = boletim.replace(/{{trimestre}}/g, this.trimestre.descricao)
            boletim = boletim.replace(/{{assinatura}}/g, assinatura)
            boletim = boletim.replace(/{{rascunho}}/g, this.rascunhoimge)
          }
                boletim = boletim.replace(/{{nomeAluno}}/g, element.nome.toUpperCase())
                boletim = boletim.replace(/{{matricula}}/g, element.matricula)
          let iteracao = documentoiter
          let resultado = this.verifyResultado(element.resultado)
              iteracao = iteracao.replace(/{{trimestre_1_2}}/g, (this.trimestre.idTrimestre === 3 ? '' : this.relatorio[0].documentoiteracao3))
              iteracao = iteracao.replace(/{{trimestre_1_2}}/g, (this.relatorio[0].documentoiteracao3))
              iteracao = iteracao.replace(/{{disciplina}}/g, element.disciplina)
              iteracao = iteracao.replace(/{{mac}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t_mac)))
              iteracao = iteracao.replace(/{{colormac}}/g, (element.t_mac && element.t_mac >= 10) ? 'transita' :'NaoTransita')

              iteracao = iteracao.replace(/{{p1}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t_nota1)))
              iteracao = iteracao.replace(/{{colorp1}}/g, (element.t_nota1 && element.t_nota1 >= 10) ? 'transita' :'NaoTransita')

              iteracao = iteracao.replace(/{{p2}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t_nota2)))
              iteracao = iteracao.replace(/{{colorp2}}/g, (element.t_nota2 && element.t_nota2 >= 10) ? 'transita' :'NaoTransita')

              iteracao = iteracao.replace(/{{md}}/g, (this.israscunho ? msgRascunho : this.isNull(element.t_md)))
              iteracao = iteracao.replace(/{{colormd}}/g, (element.t_md && element.t_md >= 10) ? 'transita' :'NaoTransita')

              boletim = boletim.replace(/{{resultado}}/g, resultado.valor)
              boletim = boletim.replace(/{{resultadocolor}}/g, resultado.classcolor)
              dados += iteracao
              elementold = this.listaAlunos[index]
        }
        let extraOptions = { 'format': 'A4',
          'border': {
            'right': '25cm',
            'left': '25cm'
          },
          'header': {
            'height': '1mm' },
          'footer': {
            'height': '1mm'
          } }
          boletim  = this.relatorio[0].css.replace(/{{boletim}}/g, boletim)
          this.boletimgerarPdf(boletim,extraOptions)
        } catch (error) {
            this.fecharPopUp()
            Swal.fire({ icon: 'error', title: 'Informação!', text: 'Ocorreu um erro ao carregar ao compor o relatório' })
        }
    },
    verifyResultado (resultado){
      return (resultado && resultado == 'Transita' ) ? {valor: 'Transita', classcolor: 'transita'} : {valor: 'Não Transita', classcolor: 'NaoTransita'} 
    },
   
    async boletimgerarPdf (boletim,option) {
       try {
         await axios({
           method: 'post',
           url: ls.get('urlReport') + ''  + 'writefile',
           data: {html: boletim,file_name: ls.get('idPessoa'),option: option}
         }).then(function (response) {
            let frame = `<html> +
            <style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style> 
            <body>
            <iframe target="_blank" type="application/pdf" src="` + ls.get('urlReport') + 'readfile/' + ls.get('idPessoa') + '.pdf' + `"></iframe> 
            </body></html>`
            let a = window.open('about:blank', '_blank', '', true)
            a.document.write(frame)
            a.document.close()
         })
         this.$store.state.isloading = false
       } catch (error) {
         Swal.fire({ icon: 'error',title: 'Informação!', text: 'Ocorreu um erro ao imprimir' })
       } finally {
        this.fecharPopUp()
       }
     },
  
    isNull (nota) {
      if (nota) { return nota } else return ''
    },
    fecharPopUp(){
                this.$store.state.isloading = false
                this.dialog = false
                this.$store.state.showDialogGuia.boletim = false
            }
      
    }
  }
  </script>
   <style>
    .tabela {
       border: 1px solid rgba(0,0,0,.12);
       font-size: 12px!important;
  
   }
    .tabelath {
       border: 1px solid rgba(0,0,0,.12);
       font-size: 12px !important;
   }
   .tdsize {
       width: 3px!important;
   }
  
   </style>
  